export default axiosInstance => {
  async function query({ jwt }) {
    return (
      await axiosInstance({
        method: "get",
        url: "/liff/operation",
        headers: { jwt }
      })
    ).data;
  }

  return {
    query
  };
};
